export default function parseHeader(string) {
  return string.toLowerCase().replace(/\s+/g, '_');
}